module.exports = __webpack_public_path__ + "3d1a7d1127947d5a5ae96f8ee140d7f1.ttf";